module.exports = __webpack_public_path__ + "img/logo.c9bc9f0a.png";